import { ArrowRight, LogIn, Sparkles, Shield, Zap } from 'lucide-react';

function App() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* Header */}
      <header className="w-full bg-secondary py-4 px-6">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <a href="https://www.the20.com" target="_blank" rel="noopener noreferrer">
            <img
              src="https://the20.com/The-20-Logo-white.png"
              alt="The 20"
              className="h-8"
            />
          </a>
          <a
            href="/company"
            className="text-sm font-medium text-white/80 hover:text-white transition-colors flex items-center gap-1.5"
          >
            <LogIn className="w-4 h-4" />
            Sign In
          </a>
        </div>
      </header>

      {/* Hero */}
      <main className="flex-1">
        <section className="relative overflow-hidden bg-gradient-to-b from-secondary to-secondary-hover">
          {/* Subtle geometric pattern */}
          <div className="absolute inset-0 opacity-5">
            <div className="absolute top-20 left-10 w-64 h-64 border border-white rounded-full" />
            <div className="absolute top-40 right-20 w-96 h-96 border border-white rounded-full" />
            <div className="absolute -bottom-20 left-1/3 w-80 h-80 border border-white rounded-full" />
          </div>

          <div className="relative max-w-4xl mx-auto px-6 py-24 md:py-36 text-center">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-1.5 mb-8 border border-white/10">
              <Sparkles className="w-4 h-4 text-primary" />
              <span className="text-sm font-medium text-white/90">Coming Soon from The 20</span>
            </div>

            <h1 className="text-4xl md:text-6xl font-black text-white leading-tight mb-6">
              AI-Powered Tools{' '}
              <span className="text-primary">Built for MSPs</span>
            </h1>

            <p className="text-lg md:text-xl text-white/70 max-w-2xl mx-auto mb-12 leading-relaxed">
              A new way to connect your favorite platforms and unlock intelligent
              automation across your entire stack. Designed exclusively for
              managed service providers.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="/signup"
                className="inline-flex items-center gap-2 bg-primary hover:bg-primary-hover text-white font-bold px-8 py-3.5 rounded-lg transition-colors text-lg shadow-lg shadow-primary/25"
              >
                Get Started
                <ArrowRight className="w-5 h-5" />
              </a>
              <a
                href="/company"
                className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white font-medium px-8 py-3.5 rounded-lg transition-colors text-lg border border-white/20"
              >
                <LogIn className="w-5 h-5" />
                Sign In
              </a>
            </div>
          </div>
        </section>

        {/* Feature hints */}
        <section className="max-w-5xl mx-auto px-6 py-20">
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-primary/10 text-primary mb-4">
                <Zap className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-bold text-secondary mb-2">Unified Access</h3>
              <p className="text-secondary/60 leading-relaxed">
                Connect multiple vendor platforms through a single, intelligent interface.
              </p>
            </div>
            <div className="text-center p-6">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-primary/10 text-primary mb-4">
                <Shield className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-bold text-secondary mb-2">Secure by Design</h3>
              <p className="text-secondary/60 leading-relaxed">
                Enterprise-grade security with per-tenant isolation and encrypted credentials.
              </p>
            </div>
            <div className="text-center p-6">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-primary/10 text-primary mb-4">
                <Sparkles className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-bold text-secondary mb-2">AI-Ready</h3>
              <p className="text-secondary/60 leading-relaxed">
                Works with the AI assistants you already use — no new tools to learn.
              </p>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="w-full bg-secondary-light border-t border-gray-200">
        <div className="max-w-6xl mx-auto px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-secondary/60">
            &copy; {new Date().getFullYear()} The 20 LLC. All rights reserved.
          </p>
          <a
            href="https://www.the20.com/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-secondary/60 hover:text-primary transition-colors"
          >
            Privacy Policy
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
